/**
 * Metadata type dropdown — OrgPilot local copy.
 * Simple select dropdown for choosing a metadata type.
 */
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@ncoder/ui";

import { ChevronDown } from "lucide-react";
import clsx from "clsx";

type OptionValue = { id: string; name: string } | null;

type Props = {
  options: any[];
  value: OptionValue;
  setValue: any;
  className?: string;
  placeholder?: string;
};

export const ChatTypeDropdown = ({
  className,
  options,
  value,
  setValue,
  placeholder = "select a metadata type",
}: Props) => {
  const handleValueChange = (selectedId: string) => {
    // Find the option and call setValue with the full object
    const option = options.find((opt: any) => String(opt.id) === selectedId);
    if (option) {
      setValue({ id: option.id, name: option.name });
    }
  };

  return (
    <Select value={value?.id || undefined} onValueChange={handleValueChange}>
      <SelectTrigger
        className={clsx(className, "text-sm flex items-center justify-between")}
      >
        <SelectValue placeholder={placeholder}>
          {value?.name || value?.id || placeholder}
        </SelectValue>

        <ChevronDown className="h-4 w-4 text-blue-500 ml-1 shrink-0" />
      </SelectTrigger>

      <SelectContent>
        {options.map((opt: any) => (
          <SelectItem key={opt.id} value={String(opt.id)}>
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground truncate max-w-[160px]">
                {opt.name}
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
